import React from 'react';
import { useTranslation } from 'react-i18next';
import OInput from '../../../UI/FormControls/OInput';

const Inputs = ({ formValues, setFormValues }) => {
  const { t, i18n } = useTranslation();
  const handleChange = (item) => {
    setFormValues((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '2px',
        marginBottom: '10px',
      }}
    >
      <OInput
        label="Naziv *"
        name="naziv"
        value={formValues.naziv}
        handleChange={handleChange}
        touched={formValues.touchedNaziv}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedNaziv: true };
          });
        }}
        errorMessage={`Naziv  ${t('isRequired')}`}
        // style={{ width: '100%' }}
      />

      <OInput
        type="number"
        label="Marža  *"
        name="marza"
        value={formValues.marza}
        handleChange={handleChange}
        touched={formValues.touchedMarza}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedMarza: true };
          });
        }}
        errorMessage={`${t('grossPrice')} ${t('isRequired')}`}

        // style={{ width: '100%' }}
      />
    </div>
  );
};

export default Inputs;
